import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { NgSelectModule } from '@ng-select/ng-select';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BrowserModule } from '@angular/platform-browser';
import { CarouselModule, ModalModule, PopoverModule, TabsModule, TooltipModule } from 'ngx-bootstrap';
import { AgmCoreModule } from '@agm/core';
import { LightboxModule } from 'ngx-lightbox';
import { GooglePlaceModule } from 'ngx-google-places-autocomplete';
import { ChartsModule } from 'ng2-charts';
import { NgxPaginationModule } from 'ngx-pagination';
import { BaseModule } from '../../base/base.module';
import { SharedModule } from '../../shared/shared/shared.module';
import { BoundariesComponent } from './boundaries/boundaries.component';
import { BoundariesEditComponent } from './boundaries-edit/boundaries-edit.component';
import { ValidationErrorComponent } from './validation-error/validation-error.component';
import { ValidationErrorDetailsComponent } from './validation-error-details/validation-error-details.component';
import { ValidationErrorDetailsGeneralComponent } from './validation-error-details/general/general.component';
import { ValidationErrorDetailsCodeComponent } from './validation-error-details/code/code.component';
import { HousingInfoService } from '../../services/housing-info/housing-info.service';
import { GoogleLocationMapper } from '../../services/googlemapper/google-location-mapper.service';
import { EmailExistenceComponent } from './email-existence/email-existence.component';
import { EmailServerBlacklistComponent } from './email-blacklist/email-server-blacklist.component';
import { EmailBouncesComponent } from './email-bounces/email-bounces.component';
import { EmailBouncesDetailsComponent } from './email-bounces-details/email-bounces-details.component';
import { ImportOnboardingsComponent } from './import-onboardings/import-onboardings.component';
import { BoundariesV2Module } from './boundaries-v2/boundaries-v2.module';
import { BoundariesActivityModule } from './boundaries-activity/boundaries-activity.module';

@NgModule({
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    CommonModule,
    BoundariesV2Module,
    BoundariesActivityModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    NgSelectModule,
    CarouselModule.forRoot(),
    TabsModule.forRoot(),
    PopoverModule.forRoot(),
    AgmCoreModule.forRoot(),
    TooltipModule.forRoot(),
    ModalModule.forRoot(),
    NgxPaginationModule,
    BaseModule,
    SharedModule,
    GooglePlaceModule,
    LightboxModule,
    ChartsModule
  ],
  declarations: [
    BoundariesComponent,
    BoundariesEditComponent,
    ValidationErrorComponent,
    ValidationErrorDetailsComponent,
    ValidationErrorDetailsGeneralComponent,
    ValidationErrorDetailsCodeComponent,
    EmailExistenceComponent,
    EmailServerBlacklistComponent,
    EmailBouncesComponent,
    EmailBouncesDetailsComponent,
    ImportOnboardingsComponent,
  ],
  providers: [
    HousingInfoService,
    GoogleLocationMapper
  ],
  exports: []
})
export class DeveloperModule {
}
